




























import { Component, Vue } from 'vue-property-decorator';
import ReminderTime from '../components/reminderTime.vue';
import { OncallReminderConfigText } from '@/config/map.conf';
import ReminderReceiver from '../components/reminderReceiver.vue';
import * as api from '@/api';
import { cloneDeep } from 'lodash';
@Component({
    components: {
        ReminderTime,
        ReminderReceiver
    }
})
export default class OncallReminder extends Vue {
    shiftReminderData: any = {};
    checkInReminderList: any = {};
    optionList: any[] = [];
    isCheckInReminderOpen: boolean = false;
    isPreReminderOpen: boolean = false;
    oncallReminderConfigText: any = OncallReminderConfigText;
    searchLoading = false;

    created() {
        this.getReminderConfig();
    }
    async getReminderConfig() {
        const res = await api.oncallApi.getReminderConfig(this.rgId);
        const { data, code } = res;
        if (code === 200 && data) {
            const { shiftReminderConfig, checkInReminderConfig } = data;
            this.shiftReminderData = Object.assign({}, shiftReminderConfig?.config);
            this.checkInReminderList = cloneDeep(checkInReminderConfig?.configList);
            this.isCheckInReminderOpen = checkInReminderConfig?.state === 'ON';
            this.isPreReminderOpen = shiftReminderConfig?.state === 'ON';
        }
    }
    async updateReminderConfig(config) {
        const res = await api.oncallApi.updateReminderConfig(this.rgId, config);
        const { code } = res;
        if (code === 200) {
            this.$mtd.message.success('更新成功');
            this.getReminderConfig();
        }
    }
    onSwitchChange(val, type: 'checkIn' | 'preReminder') {
        const requestParam = {};
        requestParam[type + 'State'] = val ? 'ON' : 'OFF';
        this.updateReminderConfig({ ...requestParam });
    }
    onTimeChanged(data, type, id?) {
        const { time, unit } = data;
        if (type === 'online') {
            this.shiftReminderData.timeValue = time;
            this.shiftReminderData.timeUnit = unit;
            this.updateReminderConfig({
                ...this.shiftReminderData
            });
        } else {
            const targetData = this.checkInReminderList.find(item => item.triggerConfigId === id);
            targetData.timeValue = time;
            targetData.timeUnit = unit;
            this.updateReminderConfig({
                ...targetData
            });
        }
    }
    onReceiverChanged(recipientData: any, id) {
        const targetData = this.checkInReminderList.find(item => item.triggerConfigId === id);
        targetData.recipient = recipientData;
        this.updateReminderConfig({
            ...targetData
        });
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
